export { default } from "./resolveProps.js";